import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
const address = 'https://queue-api.nopadol.com'
export default {
  getQueList (obj, success, error) {
    Vue.axios.post(address + '/queue/v1/list', obj).then(
      (response) => {
        success(response.data)
      },
      (response) => {
        error(response)
      }
    )
  }
}
